import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var signupOTPSendRes;
export const signupOTPSendTodo = createAsyncThunk('signupOTPSend', async (data) => {
    console.log("data", data)
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'send_direct_otp',
            data: {
                "email": data?.email
            },
            headers: { "Content-Type": "application/json" }
        })
        return signupOTPSendRes = res

    } catch (error) {
        return signupOTPSendRes = error.response
    }
})